import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        <title>VoiceAI Transient Call</title>
        <meta name="description" content="Advanced voice AI platform for intelligent transient call handling, conversation analysis, and real-time voice assistance" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0058D6" />
        <meta name="keywords" content="voice ai, transient calls, speech recognition, conversation analytics, call handling, voice assistant" />
        <meta property="og:title" content="VoiceAI Transient Call" />
        <meta property="og:description" content="Advanced voice AI platform for intelligent transient call handling, conversation analysis, and real-time voice assistance" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://myreactapp.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest"></link>
      </Helmet>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();